import {
  billingStatusTranslator,
  formatDateDayMonth,
  paymentTypeTranslator,
} from '../../../common/utils'
import { Billing } from '../../../store/data/types'
import {
  StyledContainer,
  StyledHeader,
  StyledInstallmentContainer,
  StyledInstallmentNumber,
  StyledInstallmentsInfos,
  StyledLabel,
  StyledLink,
  StyledPaymentType,
  StyledRowWrapper,
  StyledStatus,
  StyledTitle,
  StyledValue,
} from './styles/InvoiceCardTextContent.style'

export const InvoiceCardTextContent = ({
  paymentType,
  totalPrice,
  billings,
  totalDeliveredPrice,
  quantityOfPaymentInstallments,
}: {
  paymentType: number
  totalPrice: number
  billings: Billing[]
  quantityOfPaymentInstallments: number
  totalDeliveredPrice?: number
}) => {
  const generatePrice = (price: number) => price.toFixed(2).replace('.', ',')

  const hasBilling = billings ? billings.length > 0 : false
  const totalPriceBilling = hasBilling
    ? billings.reduce((a, b) => a + Number(b.billingValue), 0)
    : 0
  const hasInstallments = quantityOfPaymentInstallments > 0

  const orderedBillings = billings.sort((a, b) => a.billingDueDate.localeCompare(b.billingDueDate))

  return (
    <StyledContainer>
      <StyledRowWrapper>
        <StyledLabel>Forma de pagamento: </StyledLabel>
        <StyledPaymentType>{paymentTypeTranslator(paymentType)}</StyledPaymentType>
      </StyledRowWrapper>
      <StyledRowWrapper>
        <StyledLabel>Valor do pagamento: </StyledLabel>
        {totalDeliveredPrice ? (
          <StyledValue>{`R$ ${generatePrice(
            hasBilling ? totalPriceBilling : totalDeliveredPrice + 15
          )}`}</StyledValue>
        ) : (
          <StyledValue>{`R$ ${generatePrice(
            hasBilling ? totalPriceBilling : totalPrice + 15
          )}`}</StyledValue>
        )}
      </StyledRowWrapper>
      {hasBilling && !hasInstallments && (
        <StyledRowWrapper>
          <StyledLabel>Status do pagamento: </StyledLabel>
          <StyledValue>{billingStatusTranslator(billings[0].billingStatus)}</StyledValue>
        </StyledRowWrapper>
      )}

      {!hasBilling && hasInstallments && (
        <StyledRowWrapper>
          <StyledLabel>Você vai pagar: </StyledLabel>
          <StyledValue>{`${quantityOfPaymentInstallments}x R$ ${generatePrice(
            (totalPrice + 15) / quantityOfPaymentInstallments
          )} `}</StyledValue>
        </StyledRowWrapper>
      )}

      {hasBilling && hasInstallments && (
        <StyledContainer>
          <StyledTitle>Parcelas</StyledTitle>
          {orderedBillings.map((billing, index) => (
            <StyledInstallmentContainer key={billing.billingDueDate}>
              <StyledInstallmentsInfos>
                <StyledHeader>
                  <StyledInstallmentNumber>
                    Parcela {index + 1}/{orderedBillings.length}{' '}
                  </StyledInstallmentNumber>
                  <StyledLink href={billing.billingUrl} target="_blank">
                    Link de Pagamento
                  </StyledLink>
                </StyledHeader>
                <StyledRowWrapper>
                  Vencimento: {formatDateDayMonth(billing.billingDueDate, true)}
                </StyledRowWrapper>
                <StyledRowWrapper>
                  Valor: R$ {generatePrice(Number(billing.billingValue))}
                </StyledRowWrapper>
                <StyledRowWrapper>
                  Situação:{' '}
                  <StyledStatus status={billing.billingStatus}>
                    {billingStatusTranslator(billing.billingStatus)}
                  </StyledStatus>
                </StyledRowWrapper>
              </StyledInstallmentsInfos>
            </StyledInstallmentContainer>
          ))}
        </StyledContainer>
      )}
    </StyledContainer>
  )
}
